import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';
import { GreenroomState as GS } from '../../../stores/types/types';
import * as ModalActions from '../../../stores/actions/modal';
import Socket from '../../../connection/socket';
import { ChatRoom } from '../../../stores/reducers/chat';
import { DeleteRoom } from '../../../connection/chat';

interface Props {
	room: ChatRoom
	socket: Socket | null;
}

export default function DeleteChatRoomConfirmation({ room, socket }: Props) {
	const dispatch = useDispatch();

	const user = useSelector((s: GS) => s.SessionReducer.user);
	const token = useSelector((s: GS) => s.SessionReducer.token);
	const meeting = useSelector((s: GS) => s.SessionReducer.meeting);
	const session = useSelector((s: GS) => s.SessionReducer.session);

	const closeModal = () => {
		dispatch(ModalActions.setModalState({ modalOpen: false }));
	};

	const deleteMessage = async () => {
		if (!token || !user || !meeting || !room?.id) return;

		const deleted = await DeleteRoom(meeting.channel, room.id);

		if (deleted) {
			socket?.sendMessage('delete-chat-room', {
				room: room?.id,
			});
		}

		dispatch(ModalActions.setModalState({ modalOpen: false }));
	};

	return (
		<MultiButtonConfirmationModal
			headerText="Delete chat room?"
			bodyText="This action cannot be undone"
			firstButtonText="Delete"
			firstButtonAction={deleteMessage}
			secondButtonText="Cancel"
			secondButtonAction={closeModal}
			className="delete-chat-room-confirmation"
			isOpen
		/>
	);
}
